export default __webpack_public_path__ + "static/media/excelred_icon.c9542fcc.svg";